import React from "react";
import {
  StyledToastBanner,
  StyledToastIcon,
  StyledToastText,
} from "./Toast.styled";
import { IconManager } from "../IconManager/IconManager";
import { IconSizeEnum } from "../../../types/AppTypes";
import { ReactComponent as CheckIcon } from "../../../icons/check.svg";
import { ReactComponent as WarningIcon } from "../../../icons/warning.svg";
import { ReactComponent as ErrorIcon } from "../../../icons/close.svg";
import { theme } from "../../../constants/StyledComponents";
import { NotificationTypeEnum } from "../Notification/Notification";

export type ToastProps = {
  message: string;
  type: NotificationTypeEnum;
};

const getIcon = (type: NotificationTypeEnum): React.ReactNode => {
  switch (type) {
    case NotificationTypeEnum.SUCCESS:
      return <CheckIcon />;
    case NotificationTypeEnum.WARNING:
      return <WarningIcon />;
    case NotificationTypeEnum.ERROR:
      return <ErrorIcon />;
  }
};

export const Toast = ({ message, type }: ToastProps) => {
  return (
    <StyledToastBanner $type={type}>
      <StyledToastIcon>
        <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
          {getIcon(type)}
        </IconManager>
      </StyledToastIcon>
      <StyledToastText>{message}</StyledToastText>
    </StyledToastBanner>
  );
};
